<template>
	<popup class="select-trigger-popup"
	       :title="`${isEdit?'Edit':'Create a new'} automation`" relative @close="closePopup">
		<template v-slot:content>
			<Loading v-show="loading"/>
			<div class="__content">

				<steps-header :steps="steps" />

				<div class="step-items scroll">
					<div class="automation-step-1">
						<select-button :src="item.icon" :label="item.text" is-svg :tag="item.tag"
						               v-for="item in triggers" :key="item.id" :value="item.id"
						               v-model="automation.trigger_id"/>
					</div>
				</div>
				<div class="margin-t-15">
					<div class="alert_box grey">
						<inline-svg class="icon" :src="require('@/assets/img/info_icon.svg')" />
						<span v-if="currentTrigger">
							<b>{{currentTrigger.text}}: </b>
							<span v-html="currentTrigger.desc"></span>
						</span>
						<span v-else>
							Select an automation trigger
						</span>
					</div>
				</div>
			</div>
		</template>

		<template v-slot:actions>
			<v-button label="Continue" :disabled="!automation.trigger_id" slim @click="$emit('done',automation)" />
			<v-button label="Cancel" slim border @click="closePopup" />
		</template>
	</popup>
</template>

<script>

import API from "@/api"
import Loading from "@/components/Loading.vue"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import Step1 from "@/components/popups/automation/Step1";
import StepsHeader from "@/components/popups/automation/steps/steps-header";
import SelectButton from "@/components/base/select_button";

export default {
  name: "select-trigger-popup",
	mixins: [API],
	props:{
		automation:{type:Object},
		currentProduct:{type:Object},
		edit:{type:Object},
		productId:{},
		stepId:{},
		funnelId:{},
		isEdit:{type:Boolean},
	},
  components: {
	  SelectButton,
	  StepsHeader,
	  Step1,
    Popup,
      Loading,
      VButton
  },
  data() {
    return {
	    loading: false,
	    step: 1,
	    triggerId:0,
	    steps: [
		    {
			    id: 1, name: "Select a trigger", label: "", step: "Step1", status: "active"
		    }, {
			    id: 2, name: "Select an integration", label: "", step: "Step2", status: "deactivated"
		    }, {
			    id: 3, name: "What action to trigger?", label: "", step: "Step3", status: "deactivated"
		    }],
	    triggers: [
				{
			    id: 1,
			    icon: require('@/assets/img/cash-check.svg'),
			    text: "Purchase",
			    active: false,
					desc: "Triggered when there is a successful purchase of the product, including new subscription signups."
		    },
		    {
			    id: 5,
			    icon: require('@/assets/img/cash-sync.svg'),
			    text: "Recurring payment",
			    active: false,
			    tag:"new",
			    desc: "Triggered when a subscription has been successfully renewed or updated, this <b>doess not</b> include initial subscription payments." +
					    " <i>Supported only by Stripe and PayPal at this time.</i>",
		    },
		    {
			    id: 6,
			    icon: require('@/assets/img/cash-remove.svg'),
			    text: "Recurring payment fails",
			    tag:"new",
			    active: false,
			    desc:"Triggered when a recurring subscription payment fails at renewal." +
					    " <i>Supported only by Stripe and PayPal at this time.</i>"
		    },
		    {
			    id: 2,
			    icon: require('@/assets/img/cash-refund.svg'),
			    text: "Refund",
			    active: false,
			    desc:"Triggered when a payment has been refunded successfully.",
		    },
		    {
			    id: 3,
			    icon: require('@/assets/img/cash-clock.svg'),
			    text: "New subscription",
			    active: false,
			    desc:"Triggered when a customer signs up to a new subscription"
		    },
		    {
			    id: 4,
			    icon: require('@/assets/img/cash-minus.svg'),
			    text: "Subscription canceled",
			    active: false,
			    desc: "Triggered when an active subscription gets canceled."
		    }
	    ],
    }
  },
  computed: {
		currentTrigger() {
			if (this.automation.trigger_id) {
				return this.triggers.find(x=>x.id === this.automation.trigger_id)
			}
		}
  },
  methods: {
    closePopup() {
	    this.$emit('close');
    },
  },
	created() {
		if (this.automation) {

		}
	}
}
</script>
<style lang="scss">
.select-trigger-popup {
	.popup {
		max-width: 680px;
	}
}
</style>
<style lang="scss" scoped>
.select-trigger-popup {
	.__content {
		display: flex;
		flex-direction: column;
	}
	.automation-step-1 {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
		grid-gap: 20px;
		.select-button {
			width: 100%;
			.item {
				width: 100%;
			}
		}
	}
}
</style>

